<template>
  <g>
    <g class="y-axis">
      <path :stroke="lineColor" :d="`M0.5,0.5V${contentDimensions.height}`"/>
      <g
        v-for="(tick, index) in yTicks"
        :font-size="fontSize"
        :color="lineColor"
        text-anchor="end"
        :key="index"
        :transform="`translate(0, ${tick.position})`"
      >
        <line
          class="bar-chart-line"
          :style="intervalStyle"
          v-if="index > 0"
          :x2="contentDimensions.width"
        ></line>
        <text
          :fill="textColor"
          :x="textPadding"
          :text-anchor="textAnchor"
          :transform="textTransform"
          dy="0.32em"
        >
          {{ tick.label }}
        </text>
      </g>
    </g>
  </g>
</template>

<script>
import { bandScale, linearScale }
  from '../../../../../../../services/dashboard/graphs/scalesService';
import { bandTicks, linearTicks }
  from '../../../../../../../services/dashboard/graphs/ticksService.js';

export default {
  props: {
    // from Graph Wrapper
    data: {
      type: Array,
      required: true,
    },
    defaultChartMax: {
      type: Number,
    },
    defaultInterval: {
      type: Number,
    },
    primaryKey: {
      type: String,
    },
    secondaryKey: {
      type: String,
    },
    dimensionKey: {
      type: String,
      required: true,
    },
    contentDimensions: {
      type: Object,
      required: true,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    padding: {
      type: Number,
      default: 0,
    },
    fontSize: {
      type: Number,
      default: 12,
    },
    //  Custom to Y Axis
    rightAxis: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: String,
      default: 'linear',
      validator: v => {
        return ['linear', 'band'].indexOf(v) > -1;
      },
    },
    customChartMax: {
      type: Number,
    },
    customInterval: {
      type: Number,
    },
    isInPercentages: {
      type: Boolean,
      default: false,
    },
    textColor: {
      type: String,
      default: '#778699',
    },
    lineColor: {
      type: String,
      default: '',
    },
    intervalStyle: {
      type: String,
      default: '',
    },
    useShortLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textPadding() {
      return this.rightAxis ? this.padding : -this.padding;
    },
    textAnchor() {
      return this.rightAxis ? 'start' : 'end';
    },
    textTransform() {
      return this.rightAxis ?
        `translate(${this.contentDimensions.width}, 0)` :
        'translate(0, 0)';
    },
    chartMax() {
      return this.customChartMax || this.defaultChartMax;
    },
    interval() {
      return this.customInterval || this.defaultInterval;
    },
    yScale() {
      const linearRange = { min: this.contentDimensions.height, max: this.marginTop };
      const bandRange = { min: 0, max: this.contentDimensions.height };
      const domain = { min: 0, max: this.chartMax };

      switch (this.scale) {
        case 'band':
          return bandScale(
            this.data,
            this.dimensionKey,
            bandRange,
          );
        case 'linear':
        default:
          return linearScale(linearRange, domain);
      }
    },
    yTicks() {
      switch (this.scale) {
        case 'band':
          return bandTicks(
            this.yScale,
            this.data,
            this.dimensionKey,
            0,
            this.useShortLabel,
          );
        case 'linear':
        default:
          return linearTicks(
            this.yScale,
            this.interval,
            this.chartMax,
            this.isInPercentages,
          );
      }
    },
  },
};
</script>
